import { atom } from "jotai";
import type { GeoCheckResult } from "./geo-block";

export const geoCheckResultAtom = atom<GeoCheckResult | null>(null);
export const geoCheckLoadingAtom = atom(true);
